/**
 * Created by vladislav on 29.10.2020
 */

const CoinBlockView = BaseBlockView.extend({
    ctor: function (block) {
        this._super(block);

        const styles = cleverapps.styles.CoinBlockView;

        this.effect = "game.coinsbagblock.coinsbonus";

        this.animation = new cleverapps.Spine(bundles.game.jsons.keypad_coin_json);
        this.addChild(this.animation);
        this.animation.setAlignment(this.width / 2, this.height / 2 + styles.animation.offsetY);
        this.animation.setAnimation(0, "idle", true);

        this.setLocalZOrder(this.block.y + 100);

        this.block.on("showUp", this.createListener(this.showUp.bind(this)));
    },

    showUp: function (silent) {
        this._super(silent);

        this.animation.setAnimation(0, "showUp", false);

        this.animation.setCompleteListener(() => {
            this.animation.setAnimation(0, "showUpFinish", false);
            this.animation.setCompleteListener(() => {
                this.animation.setAnimation(0, "idle", true);
            });
        });
    }
});

cleverapps.styles.CoinBlockView = {
    animation: {
        offsetY: 5
    }
};